import { types } from "../action-types";

const initialState = {
  data: null,
  loading: false,
  success: false,
};

const TimeOffReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TIME_OFF_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case types.TIME_OFF_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
      };
    case types.TIME_OFF_FAILURE:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default TimeOffReducer;
